import { useSelector } from 'react-redux';
import { authenticationTokenSelector } from '@cp/shared/api/core';
import { useEffect, useMemo } from 'react';
import { useConfig } from '@cp/shared/config';
import { createSocket } from '../api';

export const useDialogSocket = () => {
  const cm = useConfig();
  const authToken = useSelector(authenticationTokenSelector);
  const socket = useMemo(() => {
    return createSocket({ authToken: authToken as string }, cm);
  }, [authToken, cm]);

  useEffect(() => {
    if (authToken && !socket.connected) {
      socket.connect();
    }
  }, [socket, authToken]);
  return socket;
};
